function B2() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Б2 Організаційно-методична
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="6">
                        Б2.1 Здатність забезпечувати організацію освітнього процесу у закладі дошкільної освіти з урахуванням запитів його учасників
                    </td>
                    <td>
                        Б2.1.31 Нормативно-правова база з організації освітнього процесу у закладі дошкільної освіти
                    </td>
                    <td>
                        Б2.1.У1 Організовувати освітній процес згідно з вимогами законодавчих і нормативно-правових документів
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.1.3. Особливості функціонування освітньої системи України в цілому та системи дошкільної освіти зокрема
                    </td>
                    <td>
                        Б2.1.У2 Реалізовувати освітній процес у відповідності до принципів та цінностей дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.1.3. Міжнародні тенденцій у сфері дошкільної освіти
                    </td>
                    <td>
                        Б2.1.УЗ Критично аналізувати та інтегрувати провідний педагогічний досвід у освітній процесу закладу
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.1.34. Основи дошкільної дидактики, дитячої та вікової психології
                    </td>
                    <td>
                        Б2.1.У4 Обирати та застосовувати ефективні методи, форми та засоби організації особистісно-орієнтованого освітнього процесу
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.1.35 Засади педагогіки партнерства та громадського самоврядування в закладі дошкільної освіти
                    </td>
                    <td>
                        Б2.1.У5 Залучати всіх учасників освітнього процесу до його організації та реалізації
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.1.36 Проектний менеджмент у сфері освіти
                    </td>
                    <td>
                        Б2.1.У6 Організовувати та управляти освітніми проектами, обирати адекватні критерії вивчення та оцінювання
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.2 Здатність створювати умови для ефективного функціонування &nbsp;&nbsp;&nbsp;&nbsp;команди психолого-педагогічного супроводу
                    </td>
                    <td>
                        Б2.2.31 Нормативні та організаційні засади функціонування команди психолого-педагогічного супроводу
                    </td>
                    <td>
                        Б2.2.У1 Створювати умови для ефективної взаємодії колективу закладу та команди психолого-педагогічного супроводу з метою забезпечення потреб здобувана освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б2.3 Здатність до методичної підтримки та супроводу педагогічного персоналу закладу дошкільної освіти
                    </td>
                    <td>
                        Б2.3.31 Особливості методичного супроводу освітнього процесу у закладі дошкільної освіти
                    </td>
                    <td>
                        Б2.3.У1 Використовувати ефективні форми, методи організації методичної підтримки та супроводу педагогічного персоналу
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {B2}